import React from 'react';
import './Breadcrumb.css';

/**
 * Fil d'ariane réutilisable — uniformise la navigation dans les vues profondes.
 * items : [{ label, icon?, onClick? }] — le dernier (sans onClick) = page courante.
 */
export default function Breadcrumb({ items = [] }) {
  return (
    <nav className="appcrumb" aria-label="Fil d'ariane">
      {items.map((it, i) => (
        <React.Fragment key={i}>
          {i > 0 && <span className="appcrumb-sep" aria-hidden="true">›</span>}
          {it.onClick ? (
            <button type="button" className="appcrumb-link" onClick={it.onClick}>{it.icon ? `${it.icon} ` : ''}{it.label}</button>
          ) : (
            <span className="appcrumb-cur">{it.icon ? `${it.icon} ` : ''}{it.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
